import { HomeOutlined, LogoutOutlined, SettingOutlined, SwapOutlined, UserOutlined } from '@ant-design/icons'
import { api } from '@mbfab/client-api'
import { useRedirect } from '@mbfab/frontend-common'
import { Layout, Menu } from 'antd'
import type { ItemType } from 'antd/es/menu/interface'
import Link from 'next/link'
import { useRouter } from 'next/router'

import { Logo } from '../../components/ui/Logo'
import { routes } from '../../config/routes'

import { SiderUser } from './SiderUser'

const Divider = () => <hr style={{ backgroundColor: 'white', margin: 0, borderColor: 'rgba(5, 5, 5, 0.06)' }}></hr>

export function Sider() {
  const redirect = useRedirect()
  const router = useRouter()
  const items: ItemType[] = []
  const me = api.useFetchMeSuspenseQuery().data!.me
  const myIdentity = api.useFetchMyIdentitySuspenseQuery().data!.myIdentity
  items.push({
    label: `ホーム`,
    key: '/',
    onClick: () => {
      redirect(routes.topPath(me.tenant.id))
    },
    icon: <HomeOutlined />,
  })
  items.push({
    label: `組織設定`,
    key: routes.settingPath(`[tenant_id]`),
    onClick: () => {
      redirect(routes.settingPath(me.tenant.id))
    },
    icon: <SettingOutlined />,
  })
  items.push({
    label: `ユーザー`,
    key: routes.usersPath(`[tenant_id]`),
    onClick: () => {
      redirect(routes.usersPath(me.tenant.id))
    },
    icon: <UserOutlined />,
  })
  if (myIdentity.role === 'admin') {
    items.push({
      label: `管理者用メニュー`,
      key: `admin`,
      icon: <SettingOutlined />,
      onClick: () => {
        redirect(routes.adminTenants())
      },
    })
  }
  if (myIdentity.users.length > 1) {
    items.push({
      label: `テナント切替`,
      key: routes.tenantSelectPath(),
      onClick: () => {
        redirect(routes.tenantSelectPath())
      },
      icon: <SwapOutlined />,
    })
  }
  items.push({
    label: `ログアウト`,
    key: '/sign_out',
    onClick: () => {
      redirect(routes.signOutPath())
    },
    icon: <LogoutOutlined />,
  })

  return (
    <Layout.Sider
      theme="light"
      style={{ fontWeight: 'bold', height: '100vh', borderRight: '1px solid rgba(5, 5, 5, 0.06)' }}
      className="dispaly-none-print overflow-hidden"
    >
      <div className="px-6 py-5 text-center">
        <Link href={routes.topPath(me.tenant.id)}>
          <Logo />
        </Link>
      </div>
      <Divider />
      <Menu
        items={items}
        defaultSelectedKeys={[router.pathname]}
        selectedKeys={[router.pathname]}
        mode="inline"
        theme="light"
        style={{
          paddingTop: 12,
          paddingBottom: 30,
          height: 'calc(100vh - 170px)',
          overflow: 'scroll',
          border: 'none',
        }}
      />

      {/* footer */}
      <div className="absolute z-10 w-full bg-white" style={{ bottom: 0 }}>
        <Divider />
        <SiderUser me={me} />
      </div>
    </Layout.Sider>
  )
}
